export default function ArticleSkeleton() {
  return (
    <div className="min-h-screen animate-pulse">
      {/* 1. Header & Metadata Skeleton */}
      <header className="container mx-auto px-6 pt-16 pb-8">
        {/* Category Badge */}
        <div className="flex gap-2 mb-6">
          <div className="h-6 w-20 bg-gradient-primary rounded-full" />
        </div>
        
        {/* Title */}
        <div className="space-y-4 mb-6">
          <div className="h-10 w-full bg-gradient-primary rounded-lg" />
          <div className="h-10 w-3/4 bg-gradient-primary rounded-lg" />
        </div>

        {/* Description */}
        <div className="h-6 w-5/6 bg-gray-100 rounded-md mb-8" />

        {/* Author/Date Meta */}
        <div className="flex items-center gap-6 border-b border-gray-100 pb-8">
          <div className="h-4 w-24 bg-gradient-primary rounded" />
          <div className="h-4 w-32 bg-gradient-primary rounded" />
        </div>
      </header>

      {/* 2. Featured Image Skeleton */}
      <div className="container mx-auto px-6 mb-16">
        <div className="aspect-video w-full rounded-3xl bg-gradient-primary shadow-sm" />
      </div>

      {/* 3. Main Content Skeleton */}
      <div className="container mx-auto px-6 space-y-6">
        {/* Simulating Paragraphs */}
        <div className="space-y-3">
          <div className="h-4 w-full bg-gradient-primary rounded" />
          <div className="h-4 w-full bg-gradient-primary rounded" />
          <div className="h-4 w-5/6 bg-gradient-primary rounded" />
        </div>
        
        <div className="space-y-3 pt-4">
          <div className="h-4 w-full bg-gradient-primary rounded" />
          <div className="h-4 w-11/12 bg-gradient-primary rounded" />
          <div className="h-4 w-full bg-gradient-primary rounded" />
          <div className="h-4 w-4/5 bg-gradient-primary rounded" />
        </div>

        {/* Tags Section */}
        <div className="mt-16 mb-10 pt-8 border-t border-gray-100 flex gap-3">
          <div className="h-8 w-16 bg-gradient-primary rounded-md" />
          <div className="h-8 w-16 bg-gradient-primary rounded-md" />
          <div className="h-8 w-16 bg-gradient-primary rounded-md" />
        </div>
      </div>
    </div>
  );
}